export default class OpenInNewWindow {
    #element;

    constructor(element) {
        this.#element = element;

        this.#bindEvents();
    }

    static initAll(selector) {
        Array.from(document.querySelectorAll(selector), (element) => new OpenInNewWindow(element));
    }

    #bindEvents() {
        this.#element.addEventListener('click', this.handleElementClick);
    }

    handleElementClick = (e) => {
        e.preventDefault();

        window.open(this.#element.getAttribute('href'));
    };
}
